<h1 mat-dialog-title>Asignar roles al usuario {{usuario_aplicativo}}</h1>
<div mat-dialog-content>
    <div class="shadow mt-3">
        <coky-table [title]="'Roles disponibles'" [description]="'Seleccione los roles que desea asignar al usuario'"
            [data]="rolesToAssign" (clickRow)="selectedRolesToAssign=$event" [multipleSelection]="true">
        </coky-table>
    </div>
    <div class="card mt-3">
        <div class="card-body d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
            <div class="m-1 d-flex align-items-baseline flex-column flex-sm-row">
                <h2 class="m-0 mr-2">
                    Roles seleccionados para asignar
                </h2>
                <small class="title-description">
                    {{selectedRolesToAssign.length}}
                </small>
            </div>
            <div class="d-flex align-items-center justify-content-end gap-2" *ngIf="selectedRolesToAssign.length>0">
                <button mat-flat-button type="button" class="btn" (click)="asignarRoles()">
                    Asignar
                </button>
            </div>
        </div>
    </div>

    <div class="shadow mt-3">
        <coky-table [title]="'Roles asignados'" [description]="'Seleccione los roles que desea eliminar'"
            [data]="rolesToDelete" (clickRow)="selectedRolesToDelete=$event" [multipleSelection]="true">
        </coky-table>
    </div>

    <div class="card mt-3">
        <div class="card-body d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
            <div class="m-1 d-flex align-items-baseline flex-column flex-sm-row">
                <h2 class="m-0 mr-2">
                    Roles seleccionados para a eliminar
                </h2>
                <small class="title-description">
                    {{selectedRolesToDelete.length}}
                </small>
            </div>
            <div class="d-flex align-items-center justify-content-end gap-2" *ngIf="selectedRolesToDelete.length>0">
                <button mat-flat-button type="button" class="btn" (click)="eliminarRoles()">Eliminar</button>
            </div>
        </div>
    </div>
</div>